import React from 'react';
import './SunDesigns.css';

const SunIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round">
    <circle cx="12" cy="13" r="3.6" />
    <path d="M12 3.5v2.4M5 13H2.6M21.4 13H19M6 7 4.3 5.3M18 7l1.7-1.7M3 19.5h18" />
  </svg>
);

const MoonIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round">
    <path d="M20.5 14.2A8.2 8.2 0 1 1 9.8 3.5 7.2 7.2 0 0 0 20.5 14.2Z" />
  </svg>
);

const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

// 04 · Şafak — İki tonlu · sıcak gradyan
const D4Safak = ({ vm }) => (
  <div className="gsk">
    <div className="stage">
      <div className="d4">
        <div className="d4-tile d4-tile--rise">
          <span className="d4-glow"></span>
          <div className="d4-top">
            <span className="d4-ico"><SunIcon /></span>
            <span className="d4-chip">{vm.locationDot}</span>
          </div>
          <div className="d4-label">Güneşin Doğuşu</div>
          <div className="d4-time">{vm.sunriseDst}</div>
          <div className="d4-meta">
            <span className="nrm">{vm.isDst ? <>Standart saat<b>{vm.sunriseNormal}</b></> : 'Standart saat'}</span>
            <span className="dt">{vm.dateShort}</span>
          </div>
        </div>
        <div className="d4-tile d4-tile--set">
          <span className="d4-glow"></span>
          <div className="d4-top">
            <span className="d4-ico"><MoonIcon /></span>
            <span className="d4-chip">{vm.locationDot}</span>
          </div>
          <div className="d4-label">Güneşin Batışı</div>
          <div className="d4-time">{vm.sunsetDst}</div>
          <div className="d4-meta">
            <span className="nrm">{vm.isDst ? <>Standart saat<b>{vm.sunsetNormal}</b></> : 'Standart saat'}</span>
            <span className="dt">{vm.dateShort}</span>
          </div>
        </div>
        <div className={`d4-note${vm.isDst ? ' d4-note--on' : ''}`}>
          <span className="d4-note__ico"><ClockIcon /></span>
          <span className="d4-note__txt">
            <span className="d4-note__lead">{vm.isDst ? 'Yaz saati uygulandı' : 'Yaz saati uygulanmadı'}</span>
            <span className="d4-note__sub">
              {vm.isDst ? (vm.dstRange || 'Yaz saati uygulanmıştır') : 'Gösterilen saatler standart saattir'}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default D4Safak;
